module.exports = __webpack_public_path__ + "img/1-1-Landing.81fd968c.jpg";